{
  "name": "sinapsis-admin-frontend",
  "version": "3.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --port 4200 --host 0.0.0.0",
    "build": "ng build",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "prettier": "prettier --write \"./{src,e2e}/**/*.{ts,js,html,scss}\"",
    "prettier:check": "prettier --list-different \"./{src,e2e}/**/*.{ts,js,html,scss}\"",
    "postinstall": "npm run prettier -s",
    "version": "ng version"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "~18.2.1",
    "@angular/cdk": "^18.2.1",
    "@angular/cli": "^18.2.1",
    "@angular/common": "^18.2.1",
    "@angular/compiler": "~18.2.1",
    "@angular/core": "^18.2.1",
    "@angular/forms": "~18.2.1",
    "@angular/material": "^18.2.1",
    "@angular/platform-browser": "~18.2.1",
    "@angular/platform-browser-dynamic": "~18.2.1",
    "@angular/router": "~18.2.1",
    "@auth0/angular-jwt": "^5.2.0",
    "@kolkov/angular-editor": "^3.0.0-beta.0",
    "@ngx-translate/core": "^15.0.0",
    "@tinymce/tinymce-angular": "^8.0.1",
    "@types/chart.js": "^2.9.41",
    "@types/quill": "^2.0.14",
    "bootstrap": "^5.3.3",
    "chart.js": "^4.4.6",
    "chartjs-plugin-annotation": "^3.1.0",
    "file-saver": "^2.0.2",
    "js-sha512": "^0.8.0",
    "jsondiffpatch": "^0.4.1",
    "libphonenumber-js": "^1.11.12",
    "lottie-web": "^5.12.2",
    "moment": "^2.27.0",
    "ng2-charts": "^6.0.1",
    "ngx-infinite-scroll": "^18.0.0",
    "ngx-lottie": "~12.0.0",
    "ngx-mat-intl-tel-input": "^5.0.0",
    "ngx-quill": "^26.0.8",
    "pdfmake": "^0.2.5",
    "prettier": "^2.0.2",
    "quill": "^2.0.3",
    "rxjs": "~7.8.1",
    "saturn-datepicker": "^8.0.5",
    "socket.io-client": "^2.3.0",
    "tslib": "^2.0.0",
    "typescript": "^5.5.4",
    "video.js": "^8.3.0",
    "videojs-hotkeys": "^0.2.28",
    "xng-breadcrumb": "^12.0.0",
    "zone.js": "^0.14.10"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "~18.2.1",
    "@angular/compiler-cli": "~18.2.1",
    "@angular/language-service": "^18.2.1",
    "@types/jasmine": "~5.1.4",
    "@types/jasminewd2": "~2.0.3",
    "@types/moment": "^2.13.0",
    "@types/node": "^12.20.4",
    "codelyzer": "^6.0.0",
    "jasmine-core": "^5.4.0",
    "jasmine-spec-reporter": "~7.0.0",
    "karma": "^6.0.0",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage-istanbul-reporter": "~2.1.0",
    "karma-jasmine": "~5.0.0",
    "protractor": "~7.0.0",
    "ts-node": "~8.3.0",
    "tslint": "~6.1.0"
  }
}
